import React from 'react';

/**
 * COMPONENTE: LOGO OVERLAY (VISUAL CHILD)
 * ------------------------------------------------------------------
 * Renderiza una imagen de logotipo personalizada con controles de escala,
 * orientación y posicionamiento independiente.
 * ------------------------------------------------------------------
 */
const LogoOverlay = ({ config, windowScale = 1 }) => {
    const {
        logoDataUrl,
        visible,
        scale = 1.0,
        orientation = 'horizontal', // horizontal, vertical, rot-90, rot-180, rot-270, flip-h, flip-v
        position = 'top-right',
        offsetX = 90,
        offsetY = 8
    } = config;

    if (!visible || !logoDataUrl) return null;

    // Calcular transformaciones de orientación por CSS
    let transformCss = `scale(${scale * windowScale})`;
    if (orientation === 'vertical') {
        transformCss += ' rotate(90deg)';
    } else if (orientation === 'rot-90') {
        transformCss += ' rotate(90deg)';
    } else if (orientation === 'rot-180') {
        transformCss += ' rotate(180deg)';
    } else if (orientation === 'rot-270') {
        transformCss += ' rotate(270deg)';
    } else if (orientation === 'flip-h') {
        transformCss += ' scaleX(-1)';
    } else if (orientation === 'flip-v') {
        transformCss += ' scaleY(-1)';
    }

    // Estilos del contenedor del logo
    const style = {
        position: 'absolute',
        left: `${offsetX}%`,
        top: `${offsetY}%`,
        transform: 'translate(-50%, -50%)',
        zIndex: 50,
        pointerEvents: 'none',
        transition: 'all 0.2s ease-out'
    };

    const imgStyle = {
        maxHeight: '220px',
        maxWidth: '450px',
        objectFit: 'contain',
        transform: transformCss,
        transformOrigin: 'center center',
        transition: 'transform 0.2s ease-out'
    };

    return (
        <div className="logo-overlay-container" style={style}>
            <img 
                src={logoDataUrl} 
                alt="Overlay Logo" 
                style={imgStyle} 
            />
        </div>
    );
};

export default LogoOverlay;
